import { Fill, Stroke, Style } from "ol/style";
import { FeatureLike } from "ol/Feature";
import { StyleFunction } from "ol/style/Style";

const defaultCountryStyle = new Style({
  fill: new Fill({ color: "rgba(0, 123, 255, 0.2)" }),
  stroke: new Stroke({ color: "#003366", width: 0.8 }),
});

const defaultCountryStyleDarkMode = new Style({
  fill: new Fill({ color: "rgba(0, 123, 255, 0.2)" }),
  stroke: new Stroke({ color: "#fcfcfcff", width: 0.8 }),
});

export const createCountryStyle = (
  inclusions: string[],
  darkMode = false,
): StyleFunction => {
  return (feature: FeatureLike) => {
    const countryCode = feature.get("countryCode");
    if (!inclusions.includes(countryCode)) {
      return [];
    }
    return darkMode ? defaultCountryStyleDarkMode : defaultCountryStyle;
  };
};
